<template>
    <div
        :class="[
            'flex flex-wrap gap-x-4 gap-y-1',
            'font-body-3-regular text-slate-400',
            { 'justify-center': centerAligned },
        ]"
    >
        <Link :href="route('landing-page.show', { slug: $t('footer.imprint_slug') })">
            {{ $t('footer.imprint') }}
        </Link>
        <Link :href="route('landing-page.show', { slug: $t('footer.privacy_slug') })">
            {{ $t('footer.privacy') }}
        </Link>
        <Link :href="route('landing-page.show', { slug: $t('footer.conditions_slug') })">
            {{ $t('footer.conditions') }}
        </Link>
        <Link :href="route('landing-page.show', { slug: $t('footer.right_of_withdrawal_slug') })">
            {{ $t('footer.right_of_withdrawal') }}
        </Link>
        <Link :href="route('landing-page.show', { slug: $t('communityGuidelinesPageSlug') })">
            {{ $t('communityGuidelines') }}
        </Link>
        <Link :href="route('landing-page.show', { slug: $t('footer.premium_condition_of_use_slug') })">
            {{ $t('footer.premium_condition_of_use') }}
        </Link>
        <Link :href="route('landing-page.show', { slug: 'faq' })">
            {{ $t('footer.faq') }}
        </Link>
        <Link
            :href="route('company.show', { companySlug: 'studydrive-gmbh' })"
            @click="storeJobSeekerStatus()"
        >
            {{ $t('footer.jobs_sd') }}
        </Link>
        <Link href="https://business.studydrive.net/about-us">
            {{ $t('footer.about_us') }}
        </Link>
        <a
            class="font-body-3-regular text-slate-400 cursor-pointer"
            @click="showPrivacyOptions"
            v-text="$t('footer.privacy_settings')"
        ></a>
        <Link :href="route('sitemap.index')">
            {{ $t('footer.sitemap') }}
        </Link>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import JobSeekerMixin from '@/mixins/jobSeekerMixin';
import route from '@/router/route';

export default defineComponent({
    name: 'FooterAuthLinks',
    mixins: [
        JobSeekerMixin,
    ],
    props: {
        /**
         * Whether or not to align the links in the center of the flexbox.
         */
        centerAligned: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        route,
        showPrivacyOptions(): void {
            // @ts-ignore: The __ucCmp is not available on initial page load.
            // eslint-disable-next-line no-underscore-dangle
            window.__ucCmp?.showSecondLayer();
        },
    },
});
</script>

<style lang="scss" scoped></style>
